import React from 'react'
import { withCookies } from 'react-cookie'
import version from '../version'

class Footer extends React.Component {
  render = () => (
    <footer>
      <div id='pwd_reminder'>
        <p>
          <a target='_blank' href='https://www.nlg.gr/faq/#katigoria-04'>
            {this.props.polyglot.t('faq')}
          </a>
        </p>
        <p>
          <span id='lang'>
            <a
              className={
                this.props.polyglot.locale() === 'el' ? 'inactive' : null
              }
              href='#'
              onClick={e => {
                e.preventDefault()
                this.props.cookies.set('lang', 'el', {
                  path: '/',
                  maxAge: 60 * 60 * 24 * 365 * 2
                })
                this.props.changeLang('el')
              }}
            >
              {this.props.polyglot.t('footer.lang.el')}
            </a>
            <span className='tab' />
            <a
              className={
                this.props.polyglot.locale() === 'en' ? 'inactive' : null
              }
              href='#'
              onClick={e => {
                e.preventDefault()
                this.props.cookies.set('lang', 'en', {
                  path: '/',
                  maxAge: 60 * 60 * 24 * 365 * 2
                })
                this.props.changeLang('en')
              }}
            >
              {this.props.polyglot.t('footer.lang.en')}
            </a>
          </span>
        </p>
      </div>
      <div id='copyright'>
        {this.props.polyglot.t('footer.copyright')}{' '}
        <a target='_blank' href={this.props.privacyPolicy}>
          {this.props.polyglot.t('privacyPolicy')}
        </a>{' '}
        <span id='version'>
          {this.props.polyglot.t('version', { version: version })}
        </span>
      </div>
    </footer>
  )
}

export default withCookies(Footer)
